module.exports = {
  'name': 'sqrtm',
  'category': 'Arithmetic',
  'syntax': [
    'sqrtm(x)'
  ],
  'description':
      'Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.',
  'examples': [
    'sqrtm([[1, 2], [3, 4]])'
  ],
  'seealso': [
    'sqrt',
    'abs',
    'square',
    'multiply'
  ]
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/arithmetic/sqrtm.js
// module id = 1485
// module chunks = 0